module.exports = __webpack_public_path__ + "static/businessCardsDesktop-f6342b1aa677c20bd8bd131b1539a556.png";